import {IqueryParams, Role, Roles } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createRole = async (data:Role)=> {
 return  apiService.apiRequest<Role>('post','roles',data)
};

const getRoles = async (queryParams?: { 
  page?: number, 
  page_size?: number, 
  role_name?: string,
  is_deleted?: boolean,
  search?: string 
})=> {
    const query=buildQueryString(queryParams);
   return  apiService.apiRequest<Roles[]>('get',`roles${query}`)
};

const getPermission = async (queryParams?:IqueryParams< {permission_name?: string }>) => {
    const query=buildQueryString(queryParams);
    return  apiService.apiRequest<any>('get',`roles/permissions${query}`)
};

const deleteRole = async (role_id: string) => {
    return  apiService.apiRequest<any>('delete',`roles/${role_id}`)
};

const getRole = async (role_id: string) => {
    return  apiService.apiRequest<Roles>('get',`roles/${role_id}`)
};

const updateRole = async (role_id: string,data:any) => {
    return  apiService.apiRequest<any>('put',`roles/${role_id}`,data)
};

export const rolesApi = {
  createRole,
  getRole,
  getPermission,
  getRoles,
  deleteRole,
  updateRole,
};